import { ChangeDetectionStrategy, Component, Input, ViewChild } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { DefaultGlobalConfig, ToastContainerDirective, ToastrService } from "ngx-toastr";
import { ToastPositionClass } from "../../models/toast-position-classes.model";

@UntilDestroy()
@Component({
    selector: "dtm-ui-custom-toast-wrapper",
    templateUrl: "./custom-toast-wrapper.component.html",
    styleUrls: ["./custom-toast-wrapper.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ToastrService],
})
export class CustomToastWrapperComponent {
    @Input() public positionClass: ToastPositionClass = "toast-top-center";

    @ViewChild(ToastContainerDirective) protected set boundaryViolationToastContainer(value: ToastContainerDirective) {
        this.initToastContainer(value);
    }

    constructor(public readonly toastr: ToastrService) { }

    private initToastContainer(value: ToastContainerDirective | undefined) {
        if (!value || this.toastr.overlayContainer === value) {
            return;
        }

        this.toastr.overlayContainer = value;
        this.toastr.toastrConfig = {
            ...DefaultGlobalConfig,
            autoDismiss: false,
            closeButton: true,
            tapToDismiss: false,
            disableTimeOut: true,
            positionClass: this.positionClass,
        };
    }
}
